import * as React from 'react';
import { Input, SearchInput } from '@repo/ui-web';
import { inputStates, inputSizes } from '../../catalog/component-states';
import { StateToggle } from '../../components/StateToggle';

type InputState = (typeof inputStates)[number];
type InputSize = (typeof inputSizes)[number];

export function InputShowcase() {
  const [state, setState] = React.useState<InputState>('default');
  const [size, setSize] = React.useState<InputSize>('lg');
  const [value, setValue] = React.useState('');
  const [searchQuery, setSearchQuery] = React.useState('');

  return (
    <div className="space-y-8">
      <div className="space-y-4">
        <StateToggle options={inputStates} value={state} onChange={setState} label="State" />
        <StateToggle options={inputSizes} value={size} onChange={setSize} label="Size" />
        <Input
          id="ds-input"
          label="Label"
          size={size}
          placeholder="Enter a value"
          disabled={state === 'disabled'}
          error={state === 'error' ? 'Please enter a valid email address.' : undefined}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onClear={() => setValue('')}
          clearButtonLabel="Clear value"
        />
      </div>

      <div className="space-y-2">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
          SearchInput
        </p>
        <SearchInput
          placeholder="Search..."
          onSearch={(query) => setSearchQuery(query)}
          clearButtonLabel="Clear search"
        />
        {searchQuery ? (
          <p className="type-body-sm text-muted-foreground">
            Searching for: {searchQuery}
          </p>
        ) : null}
      </div>
    </div>
  );
}
